function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { getFlushedStyles as _getFlushedStyles, purgeStyles as _purgeStyles } from 'aesthetic-utils';

var StyleSheetManager = function () {
  function StyleSheetManager() {
    _defineProperty(this, "element", void 0);

    _defineProperty(this, "sheet", void 0);

    this.element = document.createElement('style');
    this.element.type = 'text/css';
    this.element.media = 'screen';
    this.element.setAttribute('data-aesthetic', 'true');
    document.head.append(this.element);
    this.sheet = this.element.sheet;
  }

  var _proto = StyleSheetManager.prototype;

  _proto.getFlushedStyles = function getFlushedStyles() {
    return _getFlushedStyles(this.element);
  };

  _proto.injectRule = function injectRule(rule) {
    this.sheet.insertRule(rule, this.sheet.cssRules.length);
    return this;
  };

  _proto.injectStatements = function injectStatements(css) {
    this.element.textContent += css;
    return this;
  };

  _proto.purgeStyles = function purgeStyles() {
    _purgeStyles(this.element);

    return this;
  };

  return StyleSheetManager;
}();

export { StyleSheetManager as default };